export default function Divider({ className = '' }: { className?: string }) {
  return <div className={`h-px w-full bg-gray-200 dark:bg-gray-600 ${className}`} />;
}
